export default __webpack_public_path__ + "static/tooltip-critical-dont-dark-d80b9eee60f07f75b4f4bba22ace23f2b89fcb9ae02993d1e9d01cf4aa3b7fb2.png";